"use strict";

exports.__esModule = true;
exports.createStyleFunction = createStyleFunction;

var _utils = require("@chakra-ui/utils");

function createStyleFunction(config) {
  var property = config.property,
      scale = config.scale,
      _config$transform = config.transform,
      transform = _config$transform === void 0 ? _utils.getWithDefault : _config$transform,
      defaultScale = config.defaultScale;
  var properties = config.properties || [property];

  var styleFunction = function styleFunction(value, scale, props) {
    var result = {};
    var rawValue = transform(value, scale, props);
    if (rawValue === null) return;
    properties.forEach(function (prop) {
      result[prop] = rawValue;
    });
    return result;
  };

  styleFunction.scale = scale;
  styleFunction.defaults = defaultScale;
  return styleFunction;
}
//# sourceMappingURL=create-style-function.js.map